import React, { FC, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import appFlow from '../../../redux/actions/appFlow';
import { stateType } from '../../../types/types';
import { Welcome } from '../../organisms/welcome';
import AppTemplate from '../../templates/appTemplate';

export const WelcomePage: FC<any> = () => {
  // Renders the integration welcome step and advances the configured flow on logo click.
  const history = useHistory();
  const dispatch = useDispatch();
  const { routes, flowIndex } = useSelector((state: stateType) => state.appFlow);

  const handleClick = useCallback(() => {
    history.push(routes[flowIndex + 1]);
    dispatch(appFlow.setFlowIndex(flowIndex + 1));
  }, []);

  return (
    <AppTemplate submitHidden cancelHidden heading="WELCOME TO THE DYOP VISION TEST" description="test" isIntegration>
      <Welcome onLogoClick={handleClick} />
    </AppTemplate>
  );
};
